import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { useSelector } from "react-redux";
export var useProductName = function (defaultsubCategoryId) {
    var subCategoryId = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }).subCategoryId;
    var label = "";
    switch (defaultsubCategoryId ? defaultsubCategoryId : subCategoryId) {
        case ESubProductIds.NCD:
            label = "NCD";
            break;
        case ESubProductIds.StructuredProducts:
            label = "Structured Products";
            break;
        case ESubProductIds.Bonds:
            label = "Bonds";
            break;
        case ESubProductIds.UnlistedShares:
            label = "Unlisted Shares";
            break;
        default:
            label = "";
    }
    return label;
};
